export default __webpack_public_path__ + "static/media/Savant's Armbands of Awakening.462abcff.jpg";